import { useCanvasToolbarContext } from './CanvasToolbarCtx';
import { ExclusiveButtonId } from './CanvasToolbarCtx';
import { useEffect } from 'react';
import { useCallback } from 'react';

export const useCanvasFreeElementToolbarButtonBehavior = ({
  createIsActive,
  setCreateIsActive,
  buttonId,
}: {
  createIsActive: boolean;
  setCreateIsActive: (active: boolean) => void;
  buttonId: ExclusiveButtonId;
}) => {
  const { activeExclusiveButton, setActiveExclusiveButton } = useCanvasToolbarContext();

  // Deactivate when another exclusive button is activated
  useEffect(() => {
    if (activeExclusiveButton !== buttonId && createIsActive) {
      setCreateIsActive(false);
    }
  }, [activeExclusiveButton, createIsActive, setCreateIsActive, buttonId]);

  // Clear exclusive button state when creation mode is deactivated (e.g., via Escape key in tool)
  useEffect(() => {
    if (!createIsActive && activeExclusiveButton === buttonId) {
      setActiveExclusiveButton(null);
    }
  }, [createIsActive, activeExclusiveButton, buttonId, setActiveExclusiveButton]);

  const handleToggle = useCallback(
    (pressed: boolean) => {
      if (pressed) {
        setCreateIsActive(true);
        setActiveExclusiveButton(buttonId);
      } else {
        setCreateIsActive(false);
        setActiveExclusiveButton(null);
      }
    },
    [setCreateIsActive, setActiveExclusiveButton, buttonId],
  );

  return {
    handleToggle,
  };
};
